import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type DisabledFilters = {
  value: Record<number, boolean>
}

const initialState: DisabledFilters = {
  value: {},
}

const disabledSlice = createSlice({
  name: 'values',
  initialState,
  reducers: {
    setDisabledFilter(
      state,
      action: PayloadAction<{
        variable_id: number
        disabled: boolean
      }>
    ) {
      const { variable_id, disabled } = action.payload

      state.value[variable_id] = disabled
    },
    resetDisabledFilters(state) {
      state.value = {}
    },
  },
})

export const { setDisabledFilter, resetDisabledFilters } = disabledSlice.actions

export default disabledSlice.reducer
